$(document).ready(function (e) {
	$('body').on('hidden.bs.modal', '.modal', function () {
		$(this).removeData('bs.modal');
	});



	var RecaptchaOptions = {
		lang: 'ru',
		theme: 'clean'
	};



	try {
		$('[data-fancybox="true"]').fancybox({
			padding: 0,
			margin: 0,
			loop: true,
			arrows: true,
			type: 'image',
			autoSize: false,
			autoResize: true,
			autoCenter: true,
			fitToView: true,
			aspectRatio: true,
			openSpeed: 0,
			closeSpeed: 0,
			nextSpeed: 0,
			prevSpeed: 0,
			preload: 1,
			nextClick: true,
			closeBtn: true,
			maxWidth: $(window).width() * 0.8,
			maxHeight: $(window).height() * 0.8,
			title: $(this).attr('title')
		});
	} catch (ex) {
		console.log(ex);
	}



	if ($('[data-masonry="true"]').length > 0) {
		try {
			var wrapper = $('[data-masonry="true"]').masonry({
				itemSelector: '[data-masonry-item="true"]'
			});

			$('[data-masonry="true"]').find('img').on('load', function () {
				wrapper.masonry();
			});
		} catch (ex) {
			console.log(ex);
		}
	}


	$(document).on('submit', 'form[data-remote="true"]', function (e) {
		var form = $(this);

		form.find('[type="submit"]')
			.html('<i class="icon icon-spinner icon-spin"></i> Идёт отправка')
			.attr('disabled', 'disabled');

		jQuery.ajax({
			url: form.attr('action'),
			type: form.attr('method'),
			data: form.serialize(),
			dataType: 'html',
			success: function (result) {
				$(form.parents('.modal-content')[0]).html(result);
			}
		});

		e.preventDefault();
	});

});


$(document).ready(function () {
	$('[data-toggle="popover"]').popover();
});

$(function () {
	$("#myTable").tablesorter({
		sortList: [[2, 0]],
	});
});

$(function () {
	$("#myTableNew").tablesorter({
		sortList: [[1, 0]],
	});
});

//BEGIN BACK TO TOP
var scrollTop = $("#totop");
$("#totop").hide();
$(window).scroll(function () {
	if ($(this).scrollTop() > 700) {
		$("#totop").show();
	} else {
		$("#totop").hide();
	}
});
$("#totop").on('click', function () {
	$("html, body").animate({ scrollTop: 0 }, 'fast');
	return false;
});
//END BACK TO TOP

//BEGIN CallBack Hide
var scrollTop = $("#foot_phone");
$("#foot_phone").hide();
$(window).scroll(function () {
	if ($(this).scrollTop() > 180) {
		$("#foot_phone").show();
	} else {
		$("#foot_phone").hide();
	}
});
//END CallBack Hide


$(function () {
	if ($('#Container').length > 0) {
		$("#Container").mixItUp({

			animation: {
				enable: true,
				effects: 'scale fade',
				duration:500
			},


		});
	}
});
